import { h, render, Component } from 'preact';


const  search = (props) => (
	<svg id="search" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M27.3,44.8c-9.7,0-17.5-7.8-17.5-17.5c0-9.7,7.8-17.5,17.5-17.5s17.5,7.8,17.5,17.5C44.8,37,37,44.8,27.3,44.8z M50.6,44.8h-3.1l-1.1-1c3.8-4.4,6.1-10.2,6.1-16.4C52.5,13.3,41.2,2,27.3,2S2,13.3,2,27.3s11.3,25.3,25.3,25.3c6.3,0,12-2.3,16.4-6.1l1,1.1v3.1L64.2,70l5.8-5.8L50.6,44.8z" />
	</svg>
);

export default search;


// WEBPACK FOOTER //
// ../q-components/components/icons/searchIcons/search/index.js